import ADTabs from "./ADTabs";
import { getCookie } from "../../../../serviceWorker";
import TabNavigation from "../../../../common/TabNavigation";
import SubmenuHeaderView from "../../SubmenuHeaderView";
import Authorization from "../../../../generics/authorization";

const isUIConvergence = getCookie("cl-analytics");
const xValue = 0;
const wValue = 12;

const filterDashlets = isUIConvergence
  ? {
      filterDashlets: [
        {
          component: SubmenuHeaderView,
          name: "predictive-header",
          layout: { x: xValue, y: 0, w: wValue, h: 4 },
        },
      ],
    }
  : {
      filterDashlets: [
        {
          component: TabNavigation,
          name: "tab-nav",
          layout: { x: xValue, y: 0, w: wValue, h: 9 },
          style: { zIndex: 1 },
        },
      ],
    };

const pageProps = {
  ...filterDashlets,
  dashlets: [
    {
      component: ADTabs,
      name: "ad-site-tabs",
      layout: { x: xValue, y: 1, w: wValue, h: 66 },
    },
  ],
  checkPageAccess: false,
};

const Page = () => <Authorization pageProps={pageProps} />;

export default Page;
